import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getAlertsWithInvalid } from '../../services/AlertsService';
import { AlertsResponse } from '../../types/Alerts';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAlertsWithInvalid(fleetId: string, query: string, enabled = true): UseQueryResult<AlertsResponse> {
  return useQuery(
    ['alerts', fleetId, query],
    async (): Promise<AlertsResponse> => getAlertsWithInvalid(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
      enabled: !!enabled,
    },
  );
}

export default useGetAlertsWithInvalid;
